import { FieldBase } from '@/components/form/fieldBase';
import ColorPicker from '@/domain/termine/components/ColorPicker/ColorPicker';
import { ColorPickerDrawer } from '@/domain/termine/features/CreateTermin/Drawer/components/ColorPickerDrawer';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { MarkierungType } from '@/domain/termine/shared/types/Markierung';
import { useTranslation } from 'react-i18next';

export function ColorPickerFormField() {
  const { t } = useTranslation();
  const { form, isMobile } = useCreateTermineFormContext();

  return (
    <form.AppField name="markierung">
      {(field) => {
        const handleChange = (value: string) => {
          field.handleChange(value as MarkierungType);
          field.handleBlur();
        };

        return (
          <FieldBase
            label={t('domain.termine.form.fields.farbe')}
            className="w-fit">
            <>
              {isMobile ? (
                <ColorPickerDrawer
                  value={field.state.value}
                  onChange={handleChange}
                />
              ) : (
                <ColorPicker
                  value={field.state.value}
                  onChange={handleChange}
                />
              )}
            </>
          </FieldBase>
        );
      }}
    </form.AppField>
  );
}
